import { FOOD_COURT_TYPE, PARENT_TYPE } from '~/constants/logEventUser'
import { isElectronicMenu } from './getInfoRestaurant'
import { heightCategory, heightFooterSticky } from '~/constants'

/**
 * Hàm xử lý lấy ra Parent_type để log lên server
 * Parent_type: Food court, Souvenir, Hotel, Restaurant
 */
export const getParentType = (merchant_type, food_court_id) => {
  let key = merchant_type

  if (food_court_id) key = FOOD_COURT_TYPE

  return PARENT_TYPE[key]
}

/**
 * Hàm xử lý lấy ra margin của root viewport tuỳ thuộc vào trường hợp setting allow_order của bàn
 * Đối với trường hợp allow_order = true -> Viewport sẽ bị che bởi Header sticky và Footer Cart Sticky
 * nên phải điều chỉnh lại root margin viewport sao cho phù hợp
 */
export const getRootMarginViewport = (heightHeaderFixed) => {
  // trường hợp setting allow_order => sẽ có footer cart
  const top = heightCategory + heightHeaderFixed
  const bottom = heightFooterSticky

  if (isElectronicMenu()) {
    return `-${top}px 0px -${bottom}px`
  }

  return `-${top}px 0px 0px`
}
